import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCompositionApi from '@vue/composition-api';
import Notifications from 'vue-notification';
import PortalVue from 'portal-vue';
import router from '@/routes/routes';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/assets/styles/global.scss';
import '@/assets/icomoon-v1.0/style.scss';

Vue.use(VueCompositionApi);
Vue.use(Notifications);
Vue.use(VueRouter);
Vue.use(PortalVue);

Vue.config.productionTip = false;


new Vue({
  store,
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app');
